var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIcBackCard({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 18,
    height: 12.473,
    viewBox: "0 0 18 12.473",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "ic-back-card",
    d: "M16.5,32H1.5A1.5,1.5,0,0,0,0,33.5v9.473a1.5,1.5,0,0,0,1.5,1.5h15a1.5,1.5,0,0,0,1.5-1.5V33.5A1.5,1.5,0,0,0,16.5,32Zm0,10.758H1.5V33.5h15ZM3.2,41H14.75a.251.251,0,0,0,.25-.25v-.5a.251.251,0,0,0-.25-.25H3.2a.251.251,0,0,0-.25.25v.5A.251.251,0,0,0,3.2,41Zm0-2H14.75a.251.251,0,0,0,.25-.25v-.5a.251.251,0,0,0-.25-.25H3.2a.251.251,0,0,0-.25.25v.5A.251.251,0,0,0,3.2,39Zm0-2H14.75a.251.251,0,0,0,.25-.25v-.5a.251.251,0,0,0-.25-.25H3.2a.251.251,0,0,0-.25.25v.5A.251.251,0,0,0,3.2,37Z",
    transform: "translate(0 -32)"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcBackCard);
export default __webpack_public_path__ + "static/media/ic-back-card.7012bfb3ba8f574cb0cc2c444331954e.svg";
export { ForwardRef as ReactComponent };